import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

type Payload = {
  accountPayableId: string;
  memberId: string;
};

type RawData =
  | {
      outcome: 'notSet';
      reason: 'accountNotFound';
    }
  | {
      outcome: 'set';
    };

type Result = RawData;

export const useDeleteAccountPayableFromEmployeeMutation = (): MutationState<
  Payload,
  Result
> => {
  return useMutation<Payload, Result, RawData>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      method: 'delete',
      endpoint:
        '/accounting-integration/chart-of-accounts/employee-accounts/assign-account',
    },
    reshapeData: (data) => {
      return data;
    },
    options: {
      onSuccess: ({ data, client }): void => {
        if (data.outcome === 'set') {
          client.invalidateQueries(['useIntegrationStatusQuery']);
          client.invalidateQueries(['accountsPayable']);
          client.invalidateQueries(['useGetDefaultEmployeeAccountQuery']);
          client.invalidateQueries(['useGetUsersWithoutEmployeeAccountQuery']);
        }
      },
    },
  });
};
